import React from "react";
import css from "./GetStartedScreen.module.css";
import {StoreActionBlog,DataPassingBlog,WithCordovaIntro,ConfigBlog,ScriptsBlog,FolderStructureBlog,AddScreenBlog,AddWebViewBlog,SVGIconBlog,FragmentBlog,UserInputBlog,AddJsBlog,RenderListBlog,CondLayoutBlog,ExtendCpnBlog,MyFirstCpnBlog,StartAppBlog,IntroductionView,SideBarNavigator,HeaderView} from "Components";
import {isTouchDevice} from "vritra";


export default function GetStartedScreen(props){
    const {firstEntry="introduction"}=props;
    return (
        <div className={css.getstartedscreen}>
            <HeaderView className={css.header} showLibs={true} searchBarShown={!isTouchDevice()}/>
            <main className={css.main}>
                <SideBarNavigator
                    sidebarClassName={css.sidebar}
                    initialId={firstEntry}
                    fallbackEntryId={firstEntry}
                    entries={statics.entries}
                />
            </main>
        </div>
    )
}

const statics=GetStartedScreen.statics={
    entries:[
        {id:"introduction",renderContent:()=><IntroductionView/>},
        {
            id:"gettingstarted",
            name:"getting started",
            expanded:!isTouchDevice(),
            entries:[
                {
                    id:"startanewapp",
                    name:"start a new app",
                    renderContent:()=><StartAppBlog/>,
                },
                {
                    id:"folderstructure",
                    name:"folder structure",
                    renderContent:()=><FolderStructureBlog/>,
                },
                {
                    id:"availablescripts",
                    name:"Available Scripts",
                    renderContent:()=><ScriptsBlog/>,
                },
                {
                    id:"configuration",
                    renderContent:()=><ConfigBlog/>,
                },
            ],
        },
        {
            id:"learn vritra",
            expanded:!isTouchDevice(),
            entries:[
                {
                    id:"myfirstcomponent",
                    name:"my first component",
                    renderContent:()=><MyFirstCpnBlog/>,
                },
                {
                    id:"extendingcomponents",
                    name:"extending components",
                    renderContent:()=><ExtendCpnBlog/>,
                },
                {
                    id:"conditionallayout",
                    name:"conditional layout",
                    renderContent:()=><CondLayoutBlog/>,
                },
                {
                    id:"renderinglists",
                    name:"rendering lists",
                    renderContent:()=><RenderListBlog/>,
                },
                {
                    id:"addingjavascript",
                    name:"adding JavaScript",
                    renderContent:()=><AddJsBlog/>,
                },
                {
                    id:"dealingwithuserinput",
                    name:"dealing with user input",
                    renderContent:()=><UserInputBlog/>,
                },
                {
                    id:"creatingfragments",
                    name:"creating fragments",
                    renderContent:()=><FragmentBlog/>,
                },
                {
                    id:"dealingwithsvg",
                    name:"dealing with SVG",
                    renderContent:()=><SVGIconBlog/>,
                },
                {
                    id:"withcordova",
                    name:"with cordova",
                    entries:[
                        {
                            id:"withcordovaintro",
                            name:"introduction",
                            renderContent:()=><WithCordovaIntro/>
                        },
                        {
                            id:"addingwebviews",
                            name:"adding webViews",
                            renderContent:()=><AddWebViewBlog/>,
                        },
                        {
                            id:"addingscreens",
                            name:"adding screens",
                            renderContent:()=><AddScreenBlog/>,
                        },
                        {
                            id:"datapassing",
                            name:"data passing",
                            renderContent:()=><DataPassingBlog/>,
                        },
                        {
                            id:"storeactions",
                            name:"store actions",
                            renderContent:()=><StoreActionBlog/>,
                        },
                        /* {
                            id:"withionic",
                            name:"Ionic components",
                            renderContent:()=><></>,
                        }, */
                    ],
                },
            ],
        },
        /* {
            id:"examples",
            entries:[
                {id:"PrisonerView"},
            ],
        }, */
    ],
}
